var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPropellerWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1184 6.63724C9.11051 5.1026 7.98837 3.05521 7.01169 1.83332C4.67736 -1.08685 0.777566 0.356874 0.777566 0.356874C0.119519 0.600524 0.226885 0.815082 0.49703 1.07328L7.87408 8.19733C8.51481 8.81554 9.41876 9.02647 10.2465 8.75009C10.818 8.56098 11.999 8.16823 11.999 8.16823C12.1306 8.12823 12.1271 7.98277 11.954 7.97913C11.2751 7.96459 10.6067 7.39001 10.1184 6.63724Z",
    fill: "#6A41A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05835 12.0884C8.2964 13.7722 7.16733 15.8159 6.65129 17.3142C5.41139 20.8962 8.54923 23.7218 8.54923 23.7218C9.07913 24.1982 9.20035 23.9946 9.28001 23.62L11.4654 13.3503C11.6559 12.4594 11.3754 11.5321 10.7346 10.9175C10.2913 10.492 9.37699 9.61558 9.37699 9.61558C9.27655 9.51739 9.15879 9.59012 9.24538 9.75013C9.5744 10.3756 9.43586 11.2702 9.05835 12.0884Z",
    fill: "#6A41A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0877 10.3283C15.8575 10.1792 18.1087 10.1829 19.6015 9.90647C23.1757 9.24462 23.9376 4.97528 23.9376 4.97528C24.0658 4.25524 23.8372 4.24796 23.4874 4.36433L13.9215 7.51361C13.0937 7.78635 12.4669 8.50275 12.2798 9.39372C12.1517 10.0083 11.885 11.2811 11.885 11.2811C11.8538 11.4229 11.9716 11.4884 12.0616 11.332C12.4149 10.7138 13.2219 10.3938 14.0877 10.3283Z",
    fill: "#6A41A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropellerWeb);
export default __webpack_public_path__ + "static/media/propeller_web.cf6cd29f63f2b6c0a0b5f47045672471.svg";
export { ForwardRef as ReactComponent };